const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

function localeUrl(path) {
  return ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + String(path).replace(/^\//, '');
}

// Custom code matches English product titles and option values (e.g. "Premium Printing"), so
// lookups that feed logic must hit the unprefixed root, which always returns the English data.
function canonicalUrl(path) {
  return '/' + String(path).replace(/^\//, '');
}

// Replaces [key] tokens left in window.themeStrings by the Liquid `t` filter.
function themeFmt(template, values = {}) {
  return Object.keys(values).reduce(
    (text, key) => text.split('[' + key + ']').join(String(values[key])),
    template
  );
}

function storefrontLanguage() {
  const code = (document.documentElement.lang || 'en').replace('-', '_').toUpperCase();
  if (['PT_BR', 'PT_PT', 'ZH_CN', 'ZH_TW'].includes(code)) return code;
  const base = code.split('_')[0];
  return /^[A-Z]{2,3}$/.test(base) ? base : 'EN';
}
